import React, { useState, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

// Components 

import Box from '@mui/material/Box';
import Button from '../../general/inputs/Button';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { setIsLockScreenWarningPopupOpened } from '../../../redux/features/general/navigation';
import Popup from '../../general/popups/items/Popup';
import CancelButton from '../../general/inputs/CancelButton';


interface Props { 

}; 

const LockScreenWarning: React.FC<Props> = ({ }) => {

    const dispatch = useAppDispatch(); 
    const { t } = useTranslation(); 
    const navigate = useNavigate(); 

    const { consultationId } = useParams(); 

    const colors = useAppSelector(state => state.theme.colors); 
    const isLockScreenWarningPopupOpened = useAppSelector(state => state.navigation.isLockScreenWarningPopupOpened); 

    const [timeLeft, setTimeLeft] = useState(300); 

    // -- 

    const handleQuit = () => { 

        dispatch(setIsLockScreenWarningPopupOpened(false)); 

    }; 

    const formatTime = (seconds: number): string => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    };


    // -- 

    useEffect(()=>{

        let myInterval = setInterval(() => {

            if (timeLeft > 0) {

                setTimeLeft(timeLeft - 1);

            }; 


            if (timeLeft === 0) {

                if (timeLeft === 0) {
                    clearInterval(myInterval)
                };
            }; 

        }, 1000); 

        return ()=> {
            clearInterval(myInterval);
        };

    },[timeLeft]);

    // -- 

    return (

        <Popup
            containerHander={handleQuit}
        >

            <Box
                component="img"
                sx={{
                    width: 100,
                    marginTop: 3, 
                    marginBottom: 2, 
                }}
                src={require('../../../assets/icons/auth/moonlight.png')}
            />

            <Box
                sx={{ 
                    width: '50%',
                    marginBottom: 3,
                    fontWeight: 'bold',
                    fontSize: 18
                }}
            >{`${t('lockScreenLogoutWarning')} ${formatTime(timeLeft)}`}

            </Box>

            <Box
                sx={{ 
                    width: '50%',
                    marginBottom: 2 
                }}
            >{t('lockScreenWarning')}

            </Box>

            <Button 
                title={'close'}
                triggerFunction={handleQuit}
                extraStyle={{ width: 200, marginBottom: 4 }}
            />

            <CancelButton handler={handleQuit} extraStyle={{ fontSize: 30 }} />

        </Popup>

  );

};

export default LockScreenWarning;